import { render, staticRenderFns } from "./observaciones-table.vue?vue&type=template&id=296b321c&"
import script from "./observaciones-table.vue?vue&type=script&lang=ts&"
export * from "./observaciones-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports